var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h896v928H64z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416 768h192v256h-192z",
    fill: "#434854"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416 576h192v128h-192zM160 576h192v128H160zM160 768h192v128H160zM672 576h192v128h-192zM672 768h192v128h-192zM416 384h192v128h-192zM160 384h192v128H160zM672 384h192v128h-192zM416 192h192v128h-192zM160 192h192v128H160zM672 192h192v128h-192z",
    fill: "#469FCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 192h192v32H160zM416 192h192v32h-192zM672 192h192v32h-192zM160 384h192v32H160zM416 384h192v32h-192zM672 384h192v32h-192zM160 576h192v32H160zM416 576h192v32h-192zM672 576h192v32h-192zM160 768h192v32H160zM672 768h192v32h-192z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h896v32H64z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 64a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32V32a32 32 0 0 1 32-32h960a32 32 0 0 1 32 32v32z",
    fill: "#EF4D4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.24 1024A126.656 126.656 0 0 0 256 960a128 128 0 0 0-256 0c0 23.424 6.752 45.088 17.76 64h220.48zM896 832a127.744 127.744 0 0 0-116.224 75.04A94.848 94.848 0 0 0 736 896a96 96 0 0 0-96 96c0 11.296 2.304 21.952 5.888 32h360.384A126.944 126.944 0 0 0 1024 960a128 128 0 0 0-128-128z",
    fill: "#3AAD73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M779.776 907.04A94.848 94.848 0 0 0 736 896a96 96 0 0 0-96 96c0 11.296 2.304 21.952 5.888 32h139.872A126.656 126.656 0 0 1 768 960c0-18.944 4.384-36.768 11.776-52.96z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetBuilding);
export default __webpack_public_path__ + "static/media/asset-building.9eceb8c86539649ee20236c920f44998.svg";
export { ForwardRef as ReactComponent };